var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: 0px;\n  margin-bottom: 0px;\n  min-height: ', ';\n  margin-left: ', ';\n  margin-right: ', ';\n  display: ', ';\n  width: ', ';\n  max-width: ', ';\n\n  &.nowrap {\n    flex-grow: 1;\n    display: block;\n    width: 100%;\n    @media (max-width: 768px) {\n      width: 45%;\n    }\n  }\n'], ['\n  margin-top: 0px;\n  margin-bottom: 0px;\n  min-height: ', ';\n  margin-left: ', ';\n  margin-right: ', ';\n  display: ', ';\n  width: ', ';\n  max-width: ', ';\n\n  &.nowrap {\n    flex-grow: 1;\n    display: block;\n    width: 100%;\n    @media (max-width: 768px) {\n      width: 45%;\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Wrapper = styled.div(_templateObject, function (props) {
  return props.minheight ? props.minheight : '48px';
}, function (props) {
  return props.display === 'inline' ? '4px' : '0px';
}, function (props) {
  return props.display === 'inline' ? '4px' : '0px';
}, function (props) {
  return props.display ? props.display : 'block';
}, function (props) {
  return props.width ? props.width : 'auto';
}, function (props) {
  return props.maxWidth || '100%';
});

var InputContainer = function InputContainer(props) {
  return React.createElement(Wrapper, {
    minheight: props.minheight,
    display: props.display,
    width: props.width,
    maxWidth: props.maxWidth,
    className: 'input-container ' + (props.nowrap ? 'nowrap' : '')
  }, props.children);
};

export default InputContainer;